import { Component, EventEmitter, Inject, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { ApplicationFacade } from '@ridango/components';
import { TermsDialogMobileComponent } from '@ridango/components/lib/core-ui/advanced/terms-dialog-mobile/terms-dialog-mobile.component';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'rwidget-terms-and-conditions-selection',
    templateUrl: './terms-and-conditions-selection.component.html',
    styleUrls: ['./terms-and-conditions-selection.component.scss']
})
export class TermsAndConditionsSelectionComponent extends BaseComponent implements OnInit, OnDestroy {
    @Output() setTermsAgreed = new EventEmitter<boolean>();
    @Input() termsAgreed: boolean;

    public assetsPath$ = this.applicationFacade.assetsPath$;
    public termsUrl: string;
    public onlyPortraitMode$: Observable<boolean> = this.screenOrientationService.onlyPortraitMode$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private matDialog: MatDialog,
        private screenOrientationService: ScreenOrientationService
    ) {
        super();
    }

    ngOnInit() {
        this.applicationFacade.termsUrl$.pipe(takeUntil(this.componentDestroyed$)).subscribe((value) => {
            this.termsUrl = value;
        });
    }

    public async handleShowTermsConditions(): Promise<void> {
        const termsDialog = this.matDialog.open(TermsDialogMobileComponent, {
            data: { termsUrl: this.termsUrl, withAgreeButton: true, termsAgreed: this.termsAgreed },
            width: '90%',
            maxWidth: '80vh',
            autoFocus: true,
            panelClass: 'terms-dialog-mobile-wrapper'
        });
        termsDialog
            .afterClosed()
            .pipe(take(1))
            .subscribe((termsAgreed) => this.setTermsAgreed.emit(termsAgreed));
    }

    public toggleTermsAgreed(): void {
        this.setTermsAgreed.emit(!this.termsAgreed);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
